import {ChangeDetectionStrategy, Component, computed, effect, input, signal} from "@angular/core";
import {MøteId, TynnMøteModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {RopertKomponent} from "web-ng2/delt/komponenter/ropert/ropert";
import {TranslateModule} from "@ngx-translate/core";
import {Klokke} from "felles-ng2/tjenester/Klokke";
import {Sakstidspunkter} from "felles-ng2/tjenester/Sakstidspunkter";
import {PresentasjonsmodusTjeneste} from "web-ng2/tjenester/PresentasjonsmodusTjeneste";
import {toObservable, toSignal} from "@angular/core/rxjs-interop";
import {switchMap} from "rxjs";
import {map} from "rxjs/operators";
import {MatIcon} from "@angular/material/icon";
import {MøteTranskripsjon} from "../../tjenester/MøteTranskripsjon";
import {Møtedialoger} from "../../tjenester/Møtedialoger";

const debug = initDebugger('StartMøteTranskripsjonTipsKomponent');

/**
 * Viser tips om å starte lydopptak av møtet når et møte pågår og presentasjonsmodus er aktivert.
 * Tipset vises ikke mens et opptak pågår.
 */
@Component({
    selector: 'start-moete-transkripsjon-tips',
    templateUrl: 'start-møte-transkripsjon-tips.html',
    styleUrl: 'start-møte-transkripsjon-tips.scss',
    imports: [
        RopertKomponent,
        TranslateModule,
        MatIcon
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StartMøteTranskripsjonTipsKomponent {
    static ajsSelector = 'startMoeteTranskripsjonTips';

    private static erEksplisittSkjult: { [møteId: MøteId]: boolean } = {};

    moete = input.required<TynnMøteModell>();

    erAktivtMoete = toSignal(toObservable(this.moete).pipe(
      switchMap(møte => this.sakstidspunkter.forMøteSomObserverbar(møte.id)),
      map(sakstidspunkter => sakstidspunkter.harSakSomBehandlesNåPlussMinusEnTime(this.klokke.nåSomZonedDateTime()))
    ), {initialValue: false});

    tipsVises = computed(() =>
      this.erAktivtMoete() &&
      this.presentasjonsmodusTjeneste.erAktivert() &&
      !this.møteTranskripsjon.erIGang() &&
      !this.eksplisittSkjult());

    private eksplisittSkjult = signal(false);

    constructor(private klokke: Klokke,
                private sakstidspunkter: Sakstidspunkter,
                private møteTranskripsjon: MøteTranskripsjon,
                private møtedialoger: Møtedialoger,
                private presentasjonsmodusTjeneste: PresentasjonsmodusTjeneste) {
        effect(() => {
            if (StartMøteTranskripsjonTipsKomponent.erEksplisittSkjult[this.moete().id])
                this.eksplisittSkjult.set(true);
        });
    }

    async startTranskripsjon() {
        await this.møtedialoger.visStartTranskripsjon(this.moete().id);
        //tipset skjules av seg selv når opptaket er i gang, avbryter bruker dialogen skal tipset fortsatt vises
        debug('dialog lukket, opptak pågår: %o', this.møteTranskripsjon.erIGang());
    }

    skjulTips() {
        StartMøteTranskripsjonTipsKomponent.erEksplisittSkjult[this.moete().id] = true;
        this.eksplisittSkjult.set(true);
    }

}
